<!-- Bug if keep refreshing the page. It will create a new subscription -->
<script setup>
import InvoiceTable from './invoiceTable.vue'
import { useStore } from 'vuex';
import { formattedDate, swalError } from '@/helper';
import { onMounted, ref } from 'vue';
import { get_option } from '@/services/packages';
import { downloadInvoice as downloadInvoiceService } from '@/services/subscriptions';

const store = useStore()
const name = store.getters['users/name']
const email = store.getters['users/email']
const isDownloading = ref(false);

const props = defineProps({
  inv_data: {
    default: Object
  },
  payment_invoice_number: {
    type: String,
    default: ''
  },
  payment_id: {
    type: String,
    default: ''
  }
})

const company_info = ref({
  name: '',
  email: '',
  phone_number: ''
})

onMounted(async()=>{
  await get_company_info()
})

async function get_company_info(){
  let response = await get_option('company_information')
  console.log("🚀 ~ get_company_info ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  company_info.value = JSON.parse(response.result.data.attributes.name)
}

async function downloadInvoice() {
  if (props.payment_id) {
    isDownloading.value = true;
    try {
      const response = await downloadInvoiceService(props.payment_id);
      if (response.error) {
        swalError('Failed to download invoice.');
        return;
      }
      const blob = new Blob([response.result.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const contentDisposition = response.result.headers['content-disposition'];
      let filename = 'invoice.pdf';
      if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/);
          if (filenameMatch.length === 2)
              filename = filenameMatch[1];
      }
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } finally {
      isDownloading.value = false;
    }
  } else {
    swalError('Payment ID not found. Cannot download invoice.');
  }
}
</script>

<template>
  <div class="container invoice" id="print">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <div>
              <div>
                <div class="row invo-header">
                  <div class="col-sm-6">
                    <div class="d-flex align-items-center">
                      <div class="d-flex-left"><img class="d-flex-object img-60"
                        src="../../assets/images/logo/icon.png" alt="">
                      </div>
                      <div class="flex-grow-1 m-l-20">
                        <h4 class="d-flex-headin">{{ company_info.title }}</h4>
                        <p>
                          {{ company_info.email }}<br>
                          <span class="digits">{{ company_info.phone_number }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="text-md-end text-xs-center">
                      <h5>
                        Invoice #
                        <span class="digits counter">{{ payment_invoice_number || inv_data.number }}</span>
                      </h5>
                      <p>
                        Issued: <span class="digits"> {{formattedDate(new Date(inv_data.due_date * 1000).toISOString())}}</span><br>
                        Payment Due: <span class="digits">{{formattedDate(new Date(inv_data.due_date * 1000).toISOString())}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div class="row invo-profile">
                <div class="col-xl-4">
                  <div class="invo-profile-left">
                    <div class="d-flex">
                      <div class="flex-grow-1 ms-3">
                        <h4 class="d-flex-heading">{{ name }}</h4>
                        <p>
                          {{ email }}<br />
                          <!-- Phone Number -->
                          <!-- <span class="digits">555-555-5555</span> --> 
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div class="table-responsive invoice-table" id="table">
                  <InvoiceTable :lines="inv_data.lines.data" :total="inv_data.amount_paid"/>
                </div>
                <div class="row mt-3">
                  <div class="col-md-8">
                    <div>
                      <p class="legal">
                        <strong>Thank you for your business!</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 text-center mt-3">
              <router-link class="btn btn-light-primary"
                :to="{name: 'dashboard'}"
              >
                Back To Home
              </router-link>
              <button class="btn btn-light-info ms-2" type="button" @click="downloadInvoice" :disabled="isDownloading">
                <span v-if="isDownloading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span v-else>Download Invoice</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>